import { clientFor, type PageQuery, type PageResult } from '@yc/api-client'

const api = clientFor('/dsp/api')

/** 司机档案状态：在岗可被派车，停用仅是档案停用 */
export type DriverStatus = 'active' | 'disabled'

/** 司机档案。字段与 services/dsp/internal/driver/model.go 的 Driver 一一对应。 */
export interface Driver {
  id: number
  tenant_id: number
  code: string
  name: string
  phone: string
  license_type: string
  status: DriverStatus
  created_at: string
  updated_at: string
}

export interface DriverInput {
  code: string
  name?: string
  phone?: string
  license_type: string
  status: DriverStatus
}

export interface DriverQuery extends PageQuery {
  keyword?: string
  status?: string
}

/** 与后端 services/dsp/internal/driver/model.go 的 StatusNames 同源两份，改一边必须改另一边 */
export const STATUS_LABELS: Record<DriverStatus, string> = {
  active: '在岗',
  disabled: '停用',
}

/** 准驾车型白名单：与后端 services/dsp/internal/driver/model.go 的 LicenseTypes 同源两份 */
export const LICENSE_TYPES = ['A1', 'A2', 'B1', 'B2', 'C1'] as const

/** 状态 → 表格里的标签色 */
export const STATUS_TAG: Record<DriverStatus, 'info' | 'primary' | 'warning' | 'success' | 'danger'> = {
  active: 'success',
  disabled: 'info',
}

export const listDrivers = (q: DriverQuery): Promise<PageResult<Driver>> =>
  api.get<PageResult<Driver>>('/drivers', { ...q })

export const createDriver = (input: DriverInput): Promise<Driver> => api.post<Driver>('/drivers', input)

export const updateDriver = (id: number, input: DriverInput): Promise<Driver> =>
  api.put<Driver>(`/drivers/${id}`, input)

export const deleteDriver = (id: number): Promise<void> => api.del<void>(`/drivers/${id}`)

/** 下拉参照用的全量司机：后端 size 上限 200 */
export const listDriverOptions = (): Promise<Driver[]> =>
  listDrivers({ page: 1, size: 200 }).then((page) => page.list)
